import React from 'react'
import Section from '../../landingPage/Section'
import Services from "../../../components/landingPage/IconCards/CircleIconCard";
import {CompleteOral, CosmeticDentistry, Implants, InvisibleAligners} from "../../../images/index.js"

const services = [
  {
    title: "Invisible Aligners",
    description: "Service Description",
    id: 1,
    icon: InvisibleAligners
  },
  {
    title: "Cosmetic Dentistry & Smile Makeovers",
    description: "Service Description",
    id: 2,
    icon: CosmeticDentistry
  },
  {
    title: "Implants",
    description: "Service description",
    id: 3,
    icon: Implants
  },
  { 
    title: "Complete Oral Health Plans",
    description: "3D Planning & Placement Guided Surgery",
    id: 4,
    icon: CompleteOral
  },

];

function ServicesSection() {
  return (
    <Section title='Our Services' subtitle='Our partners follow the therapeutic gradient, and offer a plethora of services that include,' className="py-8 md:py-12" id="Services">
      <div className="grid grid-cols-2 lg:grid-cols-4 mx-auto justify-center max-w-screen-xl">
      {services.map(service => {
        return (
          <Services service={service} key={service.id}/>
        )
      })}
    </div>
    </Section>
  )
}

export default ServicesSection;
